import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { WaypointCategory } from '../types';
// Define colors
const colors = {
  primary: '#007AFF',
  secondary: '#5856D6',
  success: '#34C759',
  warning: '#FF9500',
  error: '#FF3B30',
  info: '#5AC8FA',
  background: '#F2F2F7',
  surface: '#FFFFFF',
  text: '#000000',
  textSecondary: '#8E8E93',
  border: '#E5E5EA',
};

// Define fonts
const fonts = {
  regular: 'System',
  semiBold: 'System',
  bold: 'System',
};

interface WaypointCategoryFilterProps {
  selectedCategory: WaypointCategory | 'all';
  onSelectCategory: (category: WaypointCategory | 'all') => void;
}

const categories: { value: WaypointCategory | 'all'; label: string; icon: string; color: string }[] = [
  { value: 'all', label: 'All', icon: 'apps', color: colors.text },
  { value: 'fishing_spot', label: 'Fishing', icon: 'phishing', color: colors.primary },
  { value: 'reef', label: 'Reef', icon: 'terrain', color: colors.success },
  { value: 'wreck', label: 'Wreck', icon: 'directions-boat', color: colors.warning },
  { value: 'structure', label: 'Structure', icon: 'account-balance', color: colors.info },
  { value: 'anchorage', label: 'Anchorage', icon: 'anchor', color: colors.secondary },
  { value: 'hazard', label: 'Hazard', icon: 'warning', color: colors.error },
  { value: 'personal', label: 'Personal', icon: 'person-pin', color: colors.text },
  { value: 'other', label: 'Other', icon: 'place', color: colors.textSecondary },
];

const WaypointCategoryFilter: React.FC<WaypointCategoryFilterProps> = ({
  selectedCategory,
  onSelectCategory,
}) => {
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
    >
      {categories.map((category) => (
        <TouchableOpacity
          key={category.value}
          style={[
            styles.categoryChip,
            selectedCategory === category.value && styles.categoryChipActive,
          ]}
          onPress={() => onSelectCategory(category.value)}
          activeOpacity={0.7}
        >
          <Icon
            name={category.icon}
            size={18}
            color={
              selectedCategory === category.value
                ? colors.background
                : category.color
            }
          />
          <Text
            style={[
              styles.categoryLabel,
              selectedCategory === category.value && styles.categoryLabelActive,
            ]}
          >
            {category.label}
          </Text>
        </TouchableOpacity>
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    maxHeight: 50,
    marginBottom: 8,
  },
  contentContainer: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    gap: 8,
  },
  categoryChip: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    backgroundColor: colors.surface,
    borderWidth: 1,
    borderColor: colors.border,
    marginRight: 8,
  },
  categoryChipActive: {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
  },
  categoryLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: colors.text,
    marginLeft: 6,
  },
  categoryLabelActive: {
    color: colors.background,
  },
});

export default WaypointCategoryFilter;